import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';

export const useFetchedFacebookAccount = () => {
  const { socialPostingApi } = useApi();
  const cacheManager = useQueryCacheManager();
  const queryKey = cacheManager.getFacebookAccountCacheKey();
  const query = useQuery(queryKey, socialPostingApi.getFacebookAccount, {
    staleTime: ReactQueryConstants.personalIntegrationSettingsStaleTime,
  });

  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="facebook"
      failedToLoadText="Something went wrong while loading Facebook integration settings."
    />
  );

  return {
    query,
    queryStatusComponent,
  };
};
